<template>
  <v-card
    class="d-flex flex-column overflow-auto kanban-column blue-grey lighten-3 px-2"
    elevation="0"
    :data-status="column.id"
  >
    <div class="d-flex justify-space-between pt-2 px-2 pb-4">
      <div class="d-flex justify-self-start" :data-status="column.id">
        <p
          class="ma-0 pa-0 subtitle-2 blue-grey--text text--darken-2 text-uppercase"
          style="font-weight: 700"
          data-tourid="task-column-name"
          :data-status="column.id"
        >
          {{ column.name }}
        </p>
        <v-skeleton-loader
          type="chip"
          class="kanban-loader-chip ms-2"
          v-if="loadingTasks"
        />
        <v-chip
          small
          color="blue-grey lighten-2"
          class="blue-grey--text text--darken-2 font-weight-500 ms-2"
          v-else
          :data-status="column.id"
        >
          {{ totalTasks }}
        </v-chip>
      </div>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            small
            icon
            class="show-hover"
            color="blue-grey darken-1"
            @click="$emit('refresh')"
          >
            <v-icon size="16">
              mdi-restore
            </v-icon>
          </v-btn>
        </template>
        {{ $t('tasks.refresh_column') }}
      </v-tooltip>
    </div>
    <div v-if="column.id === 'open'" class="pb-2">
      <InlineCreator
        class="column-inline-creator"
        hideCompleteRadio
        hideBorder
        :data-status="column.id"
        @taskWasCreated="$emit('taskCreated')"
        @addDetails="handleAddDetails"
      />
    </div>
    <div
      v-if="loadingTasks"
      class="overflow-hidden pt-2 w-100"
      :data-status="column.id"
    >
      <v-skeleton-loader
        v-for="index in tasks.length + 25"
        class="mb-2"
        type="card"
        height="107px"
        width="100%"
        :data-status="column.id"
        :key="`skeleton-${index}`"
      />
    </div>

    <DraggableVirtualList
      v-else
      data-key="id"
      handle=".kanban-content-card"
      dragClass="dragged-item"
      ghostClass="task-ghost-item"
      :swapThreshold="1"
      :emptyInsertThreshhold="100"
      :group="{ name: column.id, put: true, pull: true }"
      :class="{
        'kanban-empty-drag': !tasks.length,
        'kanban-column-content-container': tasks.length,
      }"
      :data-status="column.id"
      :size="107"
      :keeps="25"
      :data-component="TaskCard"
      :estimate-size="107"
      :scroll-sensitivity="250"
      :force-fallback="true"
      :data-sources="tasks"
      @tobottom="$emit('getMoreTasks')"
      @end="$emit('dragged', $event)"
    />
    <div
      class="d-flex align-center justify-center py-3"
      v-if="loadingMoreTasks"
    >
      <v-progress-circular indeterminate color="primary" :size="25" width="2" />
    </div>
  </v-card>
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import eventHub, { HUB_EVENTS } from '@/lib/event-hub'
import TaskCard from './TaskCard.vue'
import InlineCreator from '@/containers/TasksView/Header/InlineCreator.vue'
import DraggableVirtualList from 'vue-draggable-virtual-scroll-list'

export default {
  name: 'TaskColumn',

  mixins: [mixin, trackerMixin],

  components: {
    InlineCreator,
    DraggableVirtualList,
  },

  props: {
    totalTasks: { type: [String, Number], required: false },
    tasks: {
      type: Array,
      required: false,
    },
    column: {
      type: Object,
      required: false,
    },
    loadingTasks: {
      type: Boolean,
      required: false,
    },
    loadingMoreTasks: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      TaskCard,
    }
  },

  methods: {
    handleAddDetails(task) {
      eventHub.$emit(
        HUB_EVENTS.TASK_CREATION_DRAWER.CREATE,
        {
          ...task,
          isPrivate: true,
        },
        'tasks'
      )
    },
  },

  computed: {
    showCards() {
      return !this.loadingTasks && this.totalTasks > 0
    },
  },
}
</script>
<style lang="scss">
.kanban-column {
  width: 340px;
  max-height: 67vh;
  min-height: 100px;
}

.kanban-empty-drag {
  position: relative;
  top: 3px;
  margin-top: 7px;
  margin-bottom: 100px;
}

.column-inline-creator {
  height: 40px;
}

.kanban-column-content-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.task-ghost-item {
  cursor: grabbing !important;
  height: 100%;
  margin-top: 12px;
  background-color: $color-blue-grey-lighten2;
  border-radius: 4px;
}

.task-ghost-item * {
  visibility: hidden;
}

.ghost-item {
  opacity: 0.5;
}

.dragged-item {
  transform: rotate(5.139deg);
}

.kanban-column:hover {
  .show-hover {
    visibility: visible !important;
  }
}

.show-hover {
  visibility: hidden !important;
}

.kanban-loader-chip {
  .v-skeleton-loader__chip {
    width: 40px !important;
    height: 24px !important;
  }
}
</style>
